import React from 'react';
import { Link } from 'react-router-dom';
import * as Lucide from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { WHY_CCC } from '../mock';
import lotusIcon from '../assets/lotus-icon.png';

export default function WhyCCCSection() {
  return (
    <section className="section-pad relative overflow-hidden" style={{ background: 'linear-gradient(180deg, var(--warm-white) 0%, var(--cream) 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="card-soft p-8 md:p-12 relative overflow-hidden">
          <div className="absolute -right-16 -bottom-16 opacity-[0.08] rotate-12 pointer-events-none">
            <img src={lotusIcon} alt="" aria-hidden="true" className="w-80 h-80 object-contain" />
          </div>

          <div className="relative text-center mb-10 reveal">
            <div className="eyebrow mb-3">Why CCC</div>
            <h2 className="section-title">The <span className="text-[color:var(--dusty-rose)]">CCC</span> Difference</h2>
          </div>

          <div className="relative grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
            {WHY_CCC.map((w, i) => {
              const Icon = Lucide[w.icon] || Lucide.Check;
              return (
                <div key={w.title} className="flex gap-4 reveal" style={{ transitionDelay: `${i * 60}ms` }}>
                  <div className="w-11 h-11 rounded-full flex-shrink-0 flex items-center justify-center" style={{ background: 'rgba(141,150,119,0.14)' }}>
                    <Icon className="w-5 h-5 text-[color:var(--sage-dark)]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <h4 className="font-serif-display text-lg text-[color:var(--deep-sage)] mb-1">{w.title}</h4>
                    <p className="text-sm text-[color:var(--taupe-gray)] leading-relaxed">{w.text}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="relative text-center mt-10">
            <Link
              to="/why-ccc"
              className="btn-primary"
              aria-label="Discover why clients choose Chesapeake Counseling Center"
            >
              Discover Why Clients Choose Us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
